<template>
    <div class="room_view_menu">
        <div v-if="!is_sp">
            <img class="sukikamo_white" src="../assets/images/list_sukikamo_white.svg" alt="すきカモ">
            <img v-if="hoverFlag" class="sukikamo_white_fukidashi" src="../assets/images/list_sukikamo_white_fukidashi.svg" alt="すきカモ吹き出し">
            <div class="menu_button favorite_path" @click.stop="click" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction">
                <div>すきカモリストに追加</div>
                <div class="sukikamo_list">
                    <AddSukikamoList
                            v-if="clicked"
                            @close="clicked = false"
                            :photo_data="photo_data"
                    />
                </div>
            </div>
            <a :href="digital_catalog_link" target="_blank">
                <div class="menu_button">
                    <div>デジタルカタログを見る</div>
                </div>
            </a>
        </div>
        <div v-else style="width: 100%;">
            <div class="link_btn">
                <img class="list_btn" @click.stop="click" src="../assets/images/list_sukikamo_sp.svg" alt="すきカモリストに追加">
                <a :href="digital_catalog_link" target="_blank">
                    <img class="digital_btn" src="../assets/images/digitalcatalog_sp.svg" alt="デジタルカタログで見る">
                </a>
            </div>
            <modal name="room_favorite_modal" width="250" height="auto" @closed="clicked = false">
                <AddSukikamoList
                        class="sukikamo_list"
                        v-if="clicked"
                        @close="clicked = false"
                        :photo_data="photo_data"
                />
            </modal>
        </div>

        <modal name="menu_login_modal"  :maxWidth="600" width="90%" :adaptive="true">
            <div class="caution">お気に入り機能をご利用いただくには<br class="sp">ログインが必要です。</div>
        </modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import AddSukikamoList from './AddSukikamoList'

    export default {
        name: "RoomViewMenu",
        components: { AddSukikamoList },
        props: {
            photo_data: Object
        },
        data: () => ({
            hoverFlag: false,
            clicked: false
        }),
        computed: {
            ...mapState(["is_sp", "user_data"]),
            digital_catalog_link : _this => {
                if (!_this.photo_data) return '';

                const sample_book = _this.photo_data.tags.filter(tag => {
                    return tag.category === 'sample_book';
                }).map(tag => {
                    return tag.name_en;
                })[0];

                let url = '';
                switch(sample_book) {
                    case 'bigace':
                        url = 'https://sincol-group.jp/digitalcatalog/bigace2026/';
                        break;
                    case 'ponleum':
                        url = 'https://sincol-group.jp/digitalcatalog/ponleum2024/';
                        break;
                    case 'madory':
                        url = 'https://sincol-group.jp/digitalcatalog/madory2024/';
                        break;
                }

                //pageが数字だけを含む場合
                if (/^\d+$/.test(_this.photo_data.page)) {
                    url += `?page=${_this.photo_data.page}`;
                } else {
                    //pageが「S6」などの場合
                    //数字だけを取り出して+2するとカタログのページと一致した
                    let page_no = parseInt(_this.photo_data.page.match(/\d+/)[0]) + 2;
                    url += `#page${page_no}`;
                }
                return url;
            },
        },
        watch: {
            is_sp() {
                this.clicked = false;
                this.$modal.hide(`room_favorite_modal`);
            },
            clicked() {
                if ( !(this.is_sp && this.clicked) ) return;
                this.$modal.show(`room_favorite_modal`);
            }
        },
        methods: {
            click() {
                if ( this.user_data.id === -1 ) return this.$modal.show(`menu_login_modal`);
                this.clicked = true
            },
            mouseOverAction(){
                this.hoverFlag = true
            },
            mouseLeaveAction(){
                this.hoverFlag = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .caution{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .room_view_menu{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        img{
            vertical-align: middle;
        }
    }
    .room_view_menu .sukikamo_white {
        position: absolute;
        top: -50px;
        left: -40px;
        z-index: 10;
    }
    .room_view_menu .sukikamo_white_fukidashi {
        position: absolute;
        top: -90px;
        left: 22px;
        z-index: 10;
    }
    .menu_button{
        position: relative;
        padding: 1rem 0;
        margin-bottom: 1.5rem;
        background-color: #BA8989;
        min-width: 230px;
        text-align: center;
        cursor: pointer;
        border-radius: 5px;
        color: white;
        &:hover{
            /*opacity: 0.8;*/
        }
        .sukikamo_list{
            text-align: left;
            z-index: 15;
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translate(-50%, 100%);
        }
    }
    /*<!--.link_btn {-->*/
    /*<!--    width: 100%;-->*/
    /*<!--    display: flex;-->*/
    /*<!--    justify-content: space-between;-->*/
    /*<!--    margin: -20px 0 -50px;-->*/
    /*<!--    img {-->*/
    /*<!--        width: 100%;-->*/
    /*<!--    }-->*/
    /*<!--    .list_btn {-->*/
    /*<!--        margin-top: -10px;-->*/
    /*<!--        margin-right: 8px;-->*/
    /*<!--    }-->*/
    /*<!--}-->*/

    @media screen and (max-width:639px) {
        .link_btn {
            width: 300px;
            display: flex;
            /*justify-content: space-between;*/
            margin: -20px auto -50px;
            img {
                width: 100%;
            }
            .list_btn {
                margin-top: -10px;
                margin-right: 8px;
                /*<!--margin-left: -10px;-->*/
            }
        }
    }

</style>
